import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Identificas tus Bio-Gatillos personales usando nuestras hojas de trabajo.'
  }, {
    num: '2',
    text: 'Aplicas las sustituciones de ingredientes en tus cenas diarias.'
  }, {
    num: '3',
    text: 'Sigues la regla de los 30 minutos para asegurar que tu estómago esté vacío antes de dormir.'
  }];
  return <SectionWrapper bgColor="sage" data-id="element-84">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-forest text-center mb-12" data-id="element-85">
        Cómo funciona
      </h2>

      <div className="space-y-6 max-w-2xl mx-auto" data-id="element-86">
        {steps.map((step, index) => <div key={index} className="flex items-center gap-6 bg-white p-6 rounded-2xl shadow-sm" data-id="element-87">
            <div className="w-12 h-12 rounded-full bg-brand-amber text-white font-bold text-2xl flex items-center justify-center flex-shrink-0" data-id="element-88">
              {step.num}
            </div>
            <p className="text-xl text-gray-800 font-medium leading-tight" data-id="element-89">
              {step.text}
            </p>
          </div>)}
      </div>
    </SectionWrapper>;
}